jQuery(document).ready(function () {
	var swiper = new Swiper(".mySwiper", {
		spaceBetween: 16,
		slidesPerView: 4,
		freeMode: true,
		watchSlidesProgress: true,
	});

	var swiper2 = new Swiper(".mySwiper2", {
		spaceBetween: 10,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		thumbs: {
			swiper: swiper,
		},
	});
	
	var swiper = new Swiper('.swiper.news-event-slider', {
		loop: true,
		spaceBetween: 40,
		slidesPerView: 1,


		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	var swiperTrust = new Swiper('.juggler-slider', {
		loop: true,
		spaceBetween: 20,
		slidesPerView: 1,
		autoplay: true,

		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 5, // 👈 number of visible dots
		},

		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 4.5,
			},
		},
	});

	var whyFlyJuggler = new Swiper('.whyFlyJuggler-slider', {
		loop: true,
		spaceBetween: 30,
		slidesPerView: 1,
		autoplay: true,

		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 5, // 👈 number of visible dots
		},

		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 4,
			},
		},
	});

	var timelineSlider = new Swiper('.timeline-slider', {
		loop: true,
		spaceBetween: 8,
		slidesPerView: 1,
		slidesPerGroup: 2,
		autoplay: true,

		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 5, // 👈 number of visible dots
		},

		breakpoints: {
			0: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 2,
			},
		},
	});

	 // Open popup
	$('.popup-trigger').on('click', function () {
		$('.popup-form-outer-layer').addClass('active');
		$(this).addClass('active'); // optional: mark trigger active
	});

	$('.quiz-popup-trigger').on('click', function () {
		$('.quiz-popup-outer-layer').addClass('active');
		$(this).addClass('active'); // optional: mark trigger active
	});

	
	// Close popup
	$('.popup-cross-icn').on('click', function () {
		$('.popup-form-outer-layer').removeClass('active');
		$('.popup-trigger').removeClass('active');
		window.location.reload();
	});

	// Optional: close on outside click
	$('.popup-form-outer-layer').on('click', function (e) {
		if ($(e.target).hasClass('popup-form-outer-layer')) {
			$(this).removeClass('active');
			$('.popup-trigger').removeClass('active');
		}
	});


	$('.quiz-popup-outer-layer').on('click', function (e) {
		if ($(e.target).hasClass('quiz-popup-outer-layer')) {
			$(this).removeClass('active');
			$('.quiz-popup-trigger').removeClass('active');
		}
	});
	// QUIZ POPUP

	 $(".popup-cross-icn-2").click(function () {
	$('.quiz-popup-outer-layer').removeClass('active');
		$('.quiz-popup-trigger').removeClass('active');
		//window.location.reload();
	});

	// $('.basic_popup').click(function(){
	// 	window.location.reload();
	// })
	
	
	// Manually open the first
	// $('.accordion-header').first().addClass('active');
	// $('.accordion-content').first().slideDown(300);

	// $('.accordion-header').on('click', function () {
	// 	// console.log('hello');
	// 	const content = $(this).next('.accordion-content');
	// 	const isActive = $(this).hasClass('active');

	// 	$('.accordion-content').not(content).slideUp(300);
	// 	$('.accordion-header').not(this).removeClass('active');

	// 	$(this).toggleClass('active');
	// 	content.stop(true, true).slideToggle(300);
	// });
	

	$('.faq-categories a').click(function () {
		console.log('faqs');
		const category = $(this).data('category');
		$('.faq-categories a').removeClass('active');
		$(this).addClass('active');

		$('.accordion').removeClass('active');
		$('.accordion[data-category="' + category + '"]').addClass('active');
	});
});

jQuery(document).ready(function ($) {

  // Hide all initially
  $('.accordion-content').hide();
  $('.accordion-header').removeClass('active');

  // Delegated click (works for dynamic content)
  $(document).on('click', '.accordion-header', function () {

    const $header = $(this);
    const $content = $header.next('.accordion-content');

    if ($header.hasClass('active')) {
      $header.removeClass('active');
      $content.stop(true, true).slideUp(300);
    } else {
      $('.accordion-header').removeClass('active');
      $('.accordion-content').stop(true, true).slideUp(300);

      $header.addClass('active');
      $content.stop(true, true).slideDown(300);
    }
  });

});



// $(document).ready(function () {
// 	const lenis = new Lenis({
// 	autoRaf: true,
// 	});

//   const sr = ScrollReveal({
//     origin: 'bottom',
//     distance: '60px',
//     duration: 2500,
//     delay: 400,
//   });

//   sr.reveal(
//     '.header-wrap, .site-hero .site-common-content, .inner-hero .site-common-content, .counter-section .counter-box, .gradient-icon-box, .animation, .equipment-cateogory .site-container, .single-product-section .site-container, .premium-section, .faq-section .site-container, .g-card-section h2, .cirucs-section .grid, .c-target-section .site-container, .matt-section .site-container, .batman-section .cta-wrap, .result-hero-section h2, .timeline-section .h2, .timeline-section .site-container, .testimonial-section>.flex-col, .about-hero-section h2, .story-section .grid, .teaching-section .grid, .about-counter .site-container, .contact-hero-section h2, .address-wrapper, .shopify-policy__container, .course-header .site-container, .target-section .flex-col, .target-section .grid, .learning-section .site-container, .priority-section .site-container, .exclusive-section .site-container, .master-section .site-container, .curriculm-section .site-container, .useful-section .site-container'
//   );

// });

$(document).ready(function(){

  const $target_body = $("body");
  const $nav = $("nav");
  const $mobileBtn = $(".mobile-menu");
  const $closeBtn = $(".menu-close");
  const $dropdownIcn = $(".dropdown-icn");
  const $menuLinks = $(".site-menu a");

  // OPEN MOBILE MENU
  $mobileBtn.on("click", function(){
    if ($nav.hasClass("active")) {
		closeMenu();
	} else {
		var headerHeight = $("#shopify-section-custom_header_classic").outerHeight();
    	$nav.css("margin-top", headerHeight + "px");
		setTimeout(function(){
			$nav.addClass("active");
			$target_body.addClass("active_menu");
		}, 200);
	}
  });

  // CLOSE MENU FUNCTION
  function closeMenu(){
	$nav.removeClass("active");
    $(".site-sub-menu").removeClass("active");
	$target_body.removeClass("active_menu");
	setTimeout(function(){
			$nav.css("margin-top", "0px");
	}, 300);
  }

  // CLOSE BY CROSS ICON
  $closeBtn.on("click", function(){
    closeMenu();
  });

  $(".menu-cross-icn").on("click", function(){
	$("nav").removeClass("active");
	$(".site-sub-menu").removeClass("active");
	});

  // DROPDOWN TOGGLE
  $dropdownIcn.on("click", function(e){
    e.preventDefault();
    e.stopPropagation();

    const $parentLi = $(this).closest("li");
    const $submenu = $parentLi.find(".site-sub-menu");

    // Close other submenus
    $(".site-sub-menu").not($submenu).removeClass("active");

    // Toggle current submenu
    $submenu.toggleClass("active");
  });

  // CLICK ON ANY LINK CLOSE MENU
  $menuLinks.on("click", function(){
    closeMenu();
  });

});


document.querySelectorAll(".tabs").forEach(wrapper => {
	const tabs = wrapper.querySelectorAll(".tab-btn");
	const panels = wrapper.querySelectorAll(".tab-panel");

	tabs.forEach(tab => {
		tab.addEventListener("click", () => {
			tabs.forEach(t => t.classList.remove("active"));
			panels.forEach(p => p.classList.remove("active"));

			tab.classList.add("active");
			wrapper
				.querySelector(`#${tab.dataset.tab}`)
				.classList.add("active");
		});
	});
});


document.querySelectorAll(".inTabs").forEach(wrapper => {
	const inTabs = wrapper.querySelectorAll(".inTab-btn");
	const inPanels = wrapper.querySelectorAll(".inTab-panel");

	inTabs.forEach(tab => {
		tab.addEventListener("click", () => {
			inTabs.forEach(t => t.classList.remove("active"));
			inPanels.forEach(p => p.classList.remove("active"));

			tab.classList.add("active");
			wrapper
				.querySelector(`#${tab.dataset.tab}`)
				.classList.add("active");
		});
	});
});


document.addEventListener("DOMContentLoaded", () => {
  const filterBoxes = document.querySelectorAll(".filter-box");

  if (!filterBoxes.length) return;

  filterBoxes[0].classList.add("active");

  filterBoxes.forEach(box => {
    const title = box.querySelector(".filter-title");
    if (!title) return;

    title.addEventListener("click", () => {
      filterBoxes.forEach(item => {
        if (item !== box) item.classList.remove("active");
      });

      box.classList.toggle("active");
    });
  });
})

$(document).ready(function () {

    const gridBtns = $(".grid-btn-group .grid-btn");
    const productGrid = $(".product-grid-col");

    // ---- Default state (Switch 3 active) ----
    gridBtns.removeClass("active");
    $(".grid-btn.switch-3").addClass("active");

    productGrid.removeClass("cols-2 cols-3").addClass("cols-3");

    // ---- Click handling ----
    gridBtns.on("click", function () {

        // Change active button
        gridBtns.removeClass("active");
        $(this).addClass("active");

        // FLIP animation: record initial positions
        const firstRects = [];
        productGrid.children().each(function () {
            firstRects.push(this.getBoundingClientRect());
        });

        // Update grid columns
        productGrid.removeClass("cols-2 cols-3");

        if ($(this).hasClass("switch-2")) {
            productGrid.addClass("cols-2");
        } else if ($(this).hasClass("switch-3")) {
            productGrid.addClass("cols-3");
        }

        // Animate items to new positions
        requestAnimationFrame(() => {
            productGrid.children().each(function (i) {
                const lastRect = this.getBoundingClientRect();
                const firstRect = firstRects[i];

                // Compute the difference
                const dx = firstRect.left - lastRect.left;
                const dy = firstRect.top - lastRect.top;

                // Apply transform to invert
                this.style.transform = `translate(${dx}px, ${dy}px)`;
                this.style.transition = "none";

                // Play animation
                requestAnimationFrame(() => {
                    this.style.transition = "transform 0.45s cubic-bezier(.22,.61,.36,1)";
                    this.style.transform = "translate(0, 0)";
                });
            });
        });

    });

});

/=============== SCROLL REVEAL ANIMATION ===============/

